/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Wed Jan 03 2024
 **/

import { ChangeEvent } from "react";
import { useShallow } from "zustand/react/shallow";

import { _T } from "@rfice/language";
import { Menu, Switch } from "@/frameworks/designStuff/components";
import { useChatDataStore } from "@/modules/chat/store";

import * as S from "../emotion";

export default function ChatUIOptionMenu() {
	const { prioritySpaceChat, showFullSizeChat, toggle } = useChatDataStore(
		useShallow((state) => ({
			prioritySpaceChat: state.priority_space_chat,
			showFullSizeChat: state.show_fullsize_chat,
			toggle: state.toggle
		}))
	);
	const handleClickSidebarOption = (
		e: ChangeEvent<HTMLInputElement>,
		option: "prioritySpaceChat" | "showFullSizeChat"
	) => {
		e.stopPropagation();
		toggle(option);
	};

	return (
		<S.SubMenu className="more">
			<Menu.List maxHeight="160px">
				<Menu.Item
					css={{
						whiteSpace: "nowrap"
					}}
					align="space-between"
					typoSize="Body3_MD"
					endEnhancer={
						<Switch
							checked={prioritySpaceChat}
							onChange={(e) => handleClickSidebarOption(e, "prioritySpaceChat")}
						/>
					}
				>
					{_T("스페이스 채팅 우선 노출")}
				</Menu.Item>
				<Menu.Item
					css={{
						whiteSpace: "nowrap"
					}}
					align="space-between"
					typoSize="Body3_MD"
					endEnhancer={
						<Switch
							checked={showFullSizeChat}
							onChange={(e) => handleClickSidebarOption(e, "showFullSizeChat")}
						/>
					}
				>
					{_T("채팅방 항상 크게 보기")}
				</Menu.Item>
			</Menu.List>
		</S.SubMenu>
	);
}
